import { log, updateLoggerSessionContext, updateLoggerUserContext } from "../utils/logger";
import { UserInfo } from "./types";

const emitSessionStoreLog = (
  message: string,
  attributes: Record<string, unknown> = {},
) => {
  log({
    message,
    attributes: {
      "l9rum.session.component": "SessionStore",
      ...attributes,
    },
  });
};

let currentSessionId: string | undefined;
let previousSessionId: string | undefined;
let currentUser: UserInfo | undefined;

export function setCurrentSessionId(id: string | undefined) {
  currentSessionId = id;
  updateLoggerSessionContext(currentSessionId, previousSessionId);
}

export function setPreviousSessionId(id: string | undefined) {
  previousSessionId = id;
  updateLoggerSessionContext(currentSessionId, previousSessionId);
}

export function getCurrentSessionId() {
  return currentSessionId;
}

export function getPreviousSessionId() {
  return previousSessionId;
}

export function setCurrentUser(user: UserInfo | undefined) {
  const prevHadUser = !!currentUser;
  currentUser = user ? { ...user } : undefined;
  updateLoggerUserContext(currentUser);
  if (currentUser) {
    emitSessionStoreLog("[L9RUM Sessions] User set via identify", {
      "l9rum.session.user_keys": JSON.stringify(Object.keys(currentUser)),
    });
  } else if (prevHadUser) {
    emitSessionStoreLog("[L9RUM Sessions] User cleared via identify");
  }
}

export function getCurrentUser(): UserInfo | undefined {
  return currentUser ? { ...currentUser } : undefined;
}
